import React, { useState } from 'react';
import { inject } from 'mobx-react';

import { Form, Input, Container, Button } from 'common/lazy';

import { Message } from '../../components';
import { FieldContainer } from '../../components/FieldContainer';

const validations = {
  pin: [
    {
      isInvalid: (fields) => !fields.pin,
      message: 'Pin is required',
    },
    {
      isInvalid: (fields) => fields.pin.length !== 4,
      message: 'PIN length must be 4 characters long',
    },
  ],
  confirmPin: [
    {
      isInvalid: (fields) => !fields.confirmPin,
      message: 'Confirm PIN is required',
    },
    {
      isInvalid: (fields) => fields.confirmPin.length !== 4,
      message: 'Confirm PIN length must be 4 characters long',
    },
    {
      isInvalid: (fields) => fields.confirmPin !== fields.pin,
      message: 'PINs need to match',
    },
  ],
};

export default inject('dreamapp')(function ResetPin({ match, dreamapp }) {
  const [fieldErrors, setFieldErrors] = useState({});
  const [formData, setFormData] = useState({
    pin: '',
    confirmPin: '',
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const token = match.params.token;

  const setField = (evt) => {
    setFormData({
      ...formData,
      [evt.target.name]: evt.target.value,
    });
  };

  const validate = (fieldName) => {
    const fields = {
      pin: formData.pin,
      confirmPin: formData.confirmPin,
    };

    const newErrors = Object.keys(fields)
      .filter((key) => !fieldName || fieldName === key)
      .reduce((fieldErrors, key) => {
        const fieldValidations = validations[key];
        if (!fieldValidations?.length) return fieldErrors;

        const error = fieldValidations.find((a) => a.isInvalid(fields));
        return {
          ...fieldErrors,
          [key]: error ? error.message : null,
        };
      }, {});

    if (newErrors) {
      setFieldErrors(newErrors);
    }

    return !Object.values(fieldErrors).some(Boolean);
  };

  const onSubmit = () => {
    if (!validate()) return;

    dreamapp
      .confirmResetPin(token, formData.pin)
      .then(() => setSuccess(true))
      .catch(setError);
  };

  return (
    <Container style={{ marginTop: '48px' }}>
      <Form onSubmit={() => onSubmit()} noValidate>
        <FieldContainer error={fieldErrors.pin}>
          <label htmlFor="pin">PIN *</label>
          <Input
            fluid
            value={formData.pin}
            onChange={(evt) => setField(evt)}
            id="pin"
            type="password"
            name="pin"
            placeholder="4 digits"
          />
        </FieldContainer>
        <FieldContainer
          error={fieldErrors.confirmPin}
          style={{ marginTop: '20px' }}>
          <label htmlFor="confirmPin">Confirm PIN *</label>
          <Input
            fluid
            value={formData.confirmPin}
            onChange={(evt) => setField(evt)}
            id="confirmPin"
            type="password"
            name="confirmPin"
            placeholder="4 digits"
          />
        </FieldContainer>
        {success && (
          <Message
            content="Success"
            type="success"
            style={{ marginTop: '20px' }}
          />
        )}
        {error && (
          <Message
            content={error.message}
            type="warning"
            style={{ marginTop: '20px' }}
          />
        )}
        <Button primary style={{ marginTop: '20px' }}>
          Confirm
        </Button>
      </Form>
    </Container>
  );
});
